import type { SlideMasterProps } from '@features/powerpoint';
import { sectionHeaderBlankBackgroundV2 } from '../../images';

export const SECTION_HEADER_BLANK = 'InMarket_Section Header Blank';

export const sectionHeaderBlankSlideMasterV2: SlideMasterProps = {
  title: SECTION_HEADER_BLANK,
  background: { path: sectionHeaderBlankBackgroundV2 },
};
